import axios from 'axios';
import apiConfig from '../../api.config';
import constants from '../../../constants';
import storage from '../../../storage';

export default function updateHotelLicenceEnd(hotelWithLicences) {
  const {
    host,
    URIs: { updateHotelLicenceEnd },
  } = apiConfig;

  const uri = `${host}${updateHotelLicenceEnd}`;

  const storedCredentials = JSON.parse(storage.get(constants.AUTH.USER_KEY));

  return axios
    .post(uri, {
      accessToken: storedCredentials.accessToken,
      hotelReference: 'civitfun',
      data: hotelWithLicences,
    })
    .then(res => {
      return res.data;
    });
}
